var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useQuery } from '@apollo/client';
import GET_ORDER from 'api/queries/GET_ORDER';
import GET_SPECIFICATION_FOLDER_CONTENTS_DATA from 'api/queries/GET_SPECIFICATION_FOLDER_CONTENTS_DATA';
import React, { createContext, useEffect, useState } from 'react';
import GET_CURRENT_TENANT from 'api/queries/GET_CURRENT_TENANT';
import useOrderFolderContentsFilters from './Tabs/Specification/useOrderFolderContentsFilters';
export const OrderSpecificationContext = createContext({
    order: undefined,
    folder: undefined,
    refetchFolderContentsData: () => { },
    filters: undefined,
    changeSearch: () => { },
    changeOptions: () => { },
    folderId: undefined,
    orderLoading: true,
});
export const OrderSpecificationProvider = ({ children, orderId, }) => {
    const [orderData, setOrderData] = useState();
    const [folderContentsData, setFolderContentsData] = useState();
    const [folderId, setFolderId] = useState();
    const { data: order, refetch: refetchOrder, loading: orderLoading, } = useQuery(GET_ORDER, {
        variables: {
            id: orderId,
        },
    });
    const { data: rootFolderData } = useQuery(GET_CURRENT_TENANT);
    const { filters, handleNameChange, handleOptionsChange } = useOrderFolderContentsFilters(folderId);
    const { data: folderData, refetch: refetchFolder } = useQuery(GET_SPECIFICATION_FOLDER_CONTENTS_DATA, {
        variables: Object.assign({ modelSpecificationFolderId: folderId }, filters),
        fetchPolicy: 'network-only',
        skip: !rootFolderData,
    });
    useEffect(() => {
        var _a, _b, _c;
        setFolderId((_c = (_b = (_a = rootFolderData === null || rootFolderData === void 0 ? void 0 : rootFolderData.me) === null || _a === void 0 ? void 0 : _a.currentTenant) === null || _b === void 0 ? void 0 : _b.rootFolder) === null || _c === void 0 ? void 0 : _c.id);
    }, [rootFolderData]);
    useEffect(() => {
        setFolderContentsData(folderData === null || folderData === void 0 ? void 0 : folderData.node);
        setOrderData(order === null || order === void 0 ? void 0 : order.node);
    }, [order, folderData]);
    const refetchFolderContentsData = (modelSpecificationFolderId) => __awaiter(void 0, void 0, void 0, function* () {
        yield refetchFolder({
            modelSpecificationFolderId,
        });
        yield refetchOrder({
            id: orderId,
        });
        setFolderId(modelSpecificationFolderId);
    });
    return (React.createElement(OrderSpecificationContext.Provider, { value: {
            order: orderData,
            folder: folderContentsData,
            refetchFolderContentsData,
            filters,
            changeSearch: handleNameChange,
            changeOptions: handleOptionsChange,
            folderId,
            orderLoading,
        } }, children));
};
